/**
 * pageName: Auth Group Button's page name    string(ex. "BM10010")
 * target: Auth Group Button's target Grid    string(ex. "G01")
 * addFunc: Auth Group Button's add button event    function
 * selectFunc: Auth Group Button's select button event    function
 * saveFunc: Auth Group Button's save button event    function
 * deleteFunc: Auth Group Button's delete button event    function
 * excelFunc: Auth Group Button's excel button event    function
 *
 */

import React from "react";
/** Services Import */
import Dialog from "../Services/Common/Dialog";
import IndexedDb from "../Services/IndexedDb/IndexedDb";
/** Components Import */
import BasicButton from "./Button_Basic";
import Snackbar from "./Snackbar";
import {
  faRotateRight as RefreshIcon,
  faMagnifyingGlass as SearchIcon,
  faPlus as AddIcon,
  faFloppyDisk as SaveIcon,
  faTrash as DeleteIcon,
  faFileCsv as ExcelIcon,
} from "@fortawesome/free-solid-svg-icons";

function AuthGroupButton({
  pageName,
  target,
  refreshNone = "",
  refreshFunc = () => {
    return false;
  },
  addFunc = () => {
    return false;
  },
  selectFunc = () => {
    return false;
  },
  saveFunc = () => {
    return false;
  },
  deleteFunc = () => {
    return false;
  },
  excelFunc = () => {
    return false;
  },
}) {
  const [snackbars, setSnackbars] = React.useState({
    toggle: false,
    type: "",
    message: "",
  });
  const [authData, setAuthData] = React.useState([]);

  React.useEffect(() => {
    Init();
  }, []);

  const Init = async () => {
    Dialog.ProgressBar(true);

    try {
      await IndexedDb.GetAllDb("AuthList").then((result) => {
        setAuthData(
          result.filter(
            (f) =>
              f.mcategoCd === pageName &&
              f.detailCd.toString().substr(8) === target
          )[0]
        );
      });
    } catch (e) {
      setSnackbars({
        toggle: true,
        type: "error",
        message: e.message,
      });
    } finally {
      Dialog.ProgressBar(false);
    }
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-evenly",
        alignItems: "center",
      }}
    >
      {!authData ? null : authData.readYn === "Y" ? (
        <BasicButton
          style={{ padding: "10px 15px" }}
          icon={SearchIcon}
          onClick={() => selectFunc()}
        />
      ) : null}
      {!authData ? null : authData.createYn === "Y" ? (
        <BasicButton
          style={{ padding: "10px 15px" }}
          icon={AddIcon}
          onClick={() => addFunc()}
        />
      ) : null}
      {!authData ? null : authData.updateYn === "Y" ? (
        <BasicButton
          style={{ padding: "10px 15px" }}
          icon={SaveIcon}
          onClick={() => saveFunc()}
        />
      ) : null}
      {!authData ? null : authData.deleteYn === "Y" ? (
        <BasicButton
          style={{ padding: "10px 15px" }}
          icon={DeleteIcon}
          onClick={() => deleteFunc()}
        />
      ) : null}
      {/* {!authData ? null : authData.excelYn === "Y" ? (
        <BasicButton
          style={{ padding: "10px 15px" }}
          icon={ExcelIcon}
          onClick={() => excelFunc()}
        />
      ) : null} */}
      <BasicButton
        style={{ display: refreshNone, padding: "10px 15px" }}
        icon={RefreshIcon}
        onClick={() => refreshFunc()}
      />
      {snackbars.toggle && (
        <Snackbar snackbars={snackbars} setSnackbars={setSnackbars} />
      )}
    </div>
  );
}

AuthGroupButton.defaultProps = {};

export default AuthGroupButton;
